import { isLocalStorageAvailable } from '@/js/helpers/functions.js';

export const initTracking = () => {
    window.track = {};

    window.track.trackViewPromotion = function(data) {
        if (typeof dataLayer !== 'undefined') {
            const objectToPush = {
                event: 'view_promotion',
                ecommerce: {}
            };

            objectToPush.ecommerce.items = [];
            objectToPush.ecommerce.items.push({
                item_id: data.eventId,
                item_name: data.title,
                item_category: data.category,
                item_variant: data.variant ?? undefined,
                item_venue: data.venue,
                item_location: data.location,
                item_date: data.date,
                price: data.price ?? undefined,
                currency: data.currency ?? undefined,
                quantity: undefined,
                item_list_name: undefined,
                item_list_id: undefined,
                index: undefined,
                promotion_id: data.eventId,
                promotion_name: data.title,
                creative_slot: `Home ${data.slideIndex}`,
                creative_name: 'Home Main Slider'
            });

            dataLayer.push(objectToPush);
        }
    }

    window.track.trackSelectPromotion = function(data) {
        if (typeof dataLayer !== 'undefined') {
            const objectToPush = {
                event: 'select_promotion',
                ecommerce: {},
                eventTimeout: 2000,
                eventCallback: function() {
                    window.location = data.targetUrl;
                }
            };

            objectToPush.ecommerce.items = [];
            objectToPush.ecommerce.items.push({
                item_id: data.eventId,
                item_name: data.title,
                item_category: data.category,
                item_variant: data.variant ?? undefined,
                item_venue: data.venue,
                item_location: data.location,
                item_date: data.date,
                price: data.price ?? undefined,
                currency: data.currency ?? undefined,
                quantity: undefined,
                item_list_name: undefined,
                item_list_id: undefined,
                index: undefined,
                promotion_id: data.eventId,
                promotion_name: data.title,
                creative_slot: `Home ${data.slideIndex}`,
                creative_name: 'Home Main Slider'
            });

            if (isLocalStorageAvailable()) {
                if (Boolean(localStorage.getItem('trackItemList'))) {
                    localStorage.removeItem('trackItemList')
                }

                localStorage.setItem('trackSelectPromotion', JSON.stringify({
                    promotion_id: data.eventId,
                    promotion_name: data.title,
                    creative_slot: `Home ${data.slideIndex}`,
                    creative_name: 'Home Main Slider'
                }));
            }

            dataLayer.push(objectToPush);

            if (!window.google_tag_manager) {
                window.location = data.targetUrl;
            }
        } else {
            window.location = data.targetUrl;
        }
    }

    window.track.trackViewItemList = function(listEl) {
        if (!listEl) {
            return;
        }

        const listItems = Array.from(listEl.querySelectorAll(':scope .js-track-item-list'));

        if (typeof dataLayer !== 'undefined' && listItems.length) {
            const chunkSize = 20; // max number of objects in items list

            for (let i = 0; i < listItems.length; i += chunkSize) {
                const chunk = listItems.slice(i, i + chunkSize);
                const objectToPush = {
                    event: 'view_item_list',
                    ecommerce: {}
                };
                objectToPush.ecommerce.items = [];

                chunk.forEach(c => {
                    const data = c.dataset;

                    objectToPush.ecommerce.items.push({
                        item_id: data.eventId,
                        item_name: data.title,
                        item_category: data.category,
                        item_variant: data.variant ?? undefined,
                        item_venue: data.venue,
                        item_location: data.location,
                        item_date: data.date,
                        price: data.price ?? undefined,
                        currency: data.currency ?? undefined,
                        quantity: undefined,
                        item_list_name: data.itemListName ?? undefined,
                        item_list_id: data.itemListId,
                        index: Number(data.index) + 1,
                        promotion_id: undefined,
                        promotion_name: undefined,
                        creative_slot: undefined,
                        creative_name: undefined
                    });
                })

                dataLayer.push(objectToPush);
            }
        }
    }

    window.track.trackSelectItem = function(data) {
        if (typeof dataLayer !== 'undefined') {
            const objectToPush = {
                event: 'select_item',
                ecommerce: {},
                eventTimeout: 2000,
                eventCallback: function() {
                    window.location = data.targetUrl;
                }
            };

            objectToPush.ecommerce.items = [];
            objectToPush.ecommerce.items.push({
                item_id: data.eventId,
                item_name: data.title,
                item_category: data.category,
                item_variant: data.variant ?? undefined,
                item_venue: data.venue,
                item_location: data.location,
                item_date: data.date,
                price: data.price ?? undefined,
                currency: data.currency ?? undefined,
                quantity: undefined,
                item_list_name: data.itemListName,
                item_list_id: data.itemListId,
                index: Number(data.index) + 1,
                promotion_id: undefined,
                promotion_name: undefined,
                creative_slot: undefined,
                creative_name: undefined
            });

            if (isLocalStorageAvailable()) {
                if (Boolean(localStorage.getItem('trackSelectPromotion'))) {
                    localStorage.removeItem('trackSelectPromotion')
                }

                localStorage.setItem('trackItemList', JSON.stringify({
                    item_list_name: data.itemListName,
                    item_list_id: data.itemListId,
                }));
            }

            dataLayer.push(objectToPush);

            if (!window.google_tag_manager) {
                window.location = data.targetUrl;
            }
        } else {
            window.location = data.targetUrl;
        }
    }

    window.track.trackViewItem = function(listEl) {
        let localStorageItem = {};
        const listItems = Array.from(listEl.querySelectorAll(':scope .js-track-item'));

        if (typeof dataLayer !== 'undefined' && listItems.length) {
            if (document.referrer && document.referrer.includes('entrio') && isLocalStorageAvailable()) {
                if (Boolean(JSON.parse(localStorage.getItem('trackSelectPromotion')))) {
                    localStorageItem = JSON.parse(localStorage.getItem('trackSelectPromotion'));
                } else if (Boolean(JSON.parse(localStorage.getItem('trackItemList')))) {
                    localStorageItem = JSON.parse(localStorage.getItem('trackItemList'));
                }
            } else if (isLocalStorageAvailable()) {
                if (Boolean(localStorage.getItem('trackSelectPromotion'))) {
                    localStorage.removeItem('trackSelectPromotion')
                }

                if (Boolean(localStorage.getItem('trackItemList'))) {
                    localStorage.removeItem('trackItemList')
                }
            }

            const data = listItems[0].dataset;

            const objectToPush = {
                event: 'view_item',
                ecommerce: {}
            };
            objectToPush.ecommerce.items = [];

            objectToPush.ecommerce.items.push({
                item_id: data.eventId,
                item_name: data.title,
                item_category: data.category,
                item_variant: undefined,
                item_venue: data.venue,
                item_location: data.location,
                item_date: data.date,
                price: undefined,
                currency: undefined,
                quantity: undefined,
                item_list_name: localStorageItem.item_list_name ?? undefined,
                item_list_id: localStorageItem.item_list_id ?? undefined,
                index: Number(data.index) + 1,
                promotion_id: localStorageItem.promotion_id ?? undefined,
                promotion_name: localStorageItem.promotion_name ?? undefined,
                creative_slot: localStorageItem.creative_slot ?? undefined,
                creative_name: localStorageItem.creative_name ?? undefined
            });

            dataLayer.push(objectToPush);
        }
    }

    window.track.addToCart = function(listEl, isRegularShopType) {
        let localStorageItem = {};
        const listItems = Array.from(listEl.querySelectorAll(':scope .js-track-cart-item'));

        const listItemsFiltered = listItems.filter((item) => {
            if (isRegularShopType) {
                if (item.querySelector(':scope .js-track-quantity')) {
                    const quantity = Number(item.querySelector(':scope .js-track-quantity').value);

                    if (Boolean(quantity)) {
                        return item.dataset.quantity = quantity;
                    }
                }
            } else {
                const quantity = Number(document.querySelectorAll(`[data-track-quantity="${item.dataset.variant}"]`).length / 2);

                if (Boolean(quantity)) {
                    return item.dataset.quantity = quantity;
                }
            }
        })

        if (typeof dataLayer !== 'undefined' && listItemsFiltered.length) {
            if (Boolean(JSON.parse(localStorage.getItem('trackSelectPromotion'))) && isLocalStorageAvailable()) {
                localStorageItem = JSON.parse(localStorage.getItem('trackSelectPromotion'));
            } else if (Boolean(JSON.parse(localStorage.getItem('trackItemList'))) && isLocalStorageAvailable()) {
                localStorageItem = JSON.parse(localStorage.getItem('trackItemList'));
            }

            const chunkSize = 20; // max number of objects in items list

            for (let i = 0; i < listItemsFiltered.length; i += chunkSize) {
                const chunk = listItemsFiltered.slice(i, i + chunkSize);
                const objectToPush = {
                    event: 'add_to_cart',
                    ecommerce: {}
                };
                objectToPush.ecommerce.items = [];

                chunk.forEach(c => {
                    const data = c.dataset;
                    let pricePerTicketWithDiscount = null;
                    let discount = 0;

                    if (data.discountName && data.discountCount && data.discountPerTicket) {
                        const priceWithoutDiscount = Number(data.quantity) * Number(data.price);
                        const qtyForDiscount = Number(data.quantity) > Number(data.discountCount) ? Number(data.discountCount) : Number(data.quantity);
                        const totalDiscount = Number(data.discountPerTicket) * qtyForDiscount;

                        pricePerTicketWithDiscount = (priceWithoutDiscount - totalDiscount) / Number(data.quantity);
                        discount = totalDiscount / Number(data.quantity);
                    }

                    objectToPush.ecommerce.items.push({
                        item_id: data.eventId,
                        item_name: data.title,
                        item_category: data.category,
                        item_variant: data.variant,
                        item_venue: data.venue,
                        item_location: data.location,
                        item_date: data.date,
                        price: pricePerTicketWithDiscount ?? Number(data.price),
                        discount: discount,
                        coupon: data.discountName ?? undefined,
                        currency: data.currency,
                        quantity: Number(data.quantity),
                        item_list_name: localStorageItem.item_list_name ?? undefined,
                        item_list_id: localStorageItem.item_list_id ?? undefined,
                        index: Number(data.index) + 1,
                        promotion_id: localStorageItem.promotion_id ?? undefined,
                        promotion_name: localStorageItem.promotion_name ?? undefined,
                        creative_slot: localStorageItem.creative_slot ?? undefined,
                        creative_name: localStorageItem.creative_name ?? undefined
                    });
                })
                dataLayer.push(objectToPush);
            }
        }
    }

    window.track.trackViewCart = function(listEl) {
        let localStorageItem = {};
        const listItems = Array.from(listEl.querySelectorAll(':scope .js-track-cart-item'));

        if (typeof dataLayer !== 'undefined' && listItems.length) {
            if (Boolean(JSON.parse(localStorage.getItem('trackSelectPromotion'))) && isLocalStorageAvailable()) {
                localStorageItem = JSON.parse(localStorage.getItem('trackSelectPromotion'));
            } else if (Boolean(JSON.parse(localStorage.getItem('trackItemList'))) && isLocalStorageAvailable()) {
                localStorageItem = JSON.parse(localStorage.getItem('trackItemList'));
            }

            const chunkSize = 20; // max number of objects in items list

            for (let i = 0; i < listItems.length; i += chunkSize) {
                const chunk = listItems.slice(i, i + chunkSize);
                const objectToPush = {
                    event: 'view_cart',
                    ecommerce: {}
                };
                objectToPush.ecommerce.items = [];

                chunk.forEach(c => {
                    const data = c.dataset;
                    let pricePerTicketWithDiscount = null;
                    let discount = 0;

                    if (data.discountName && data.discountCount && data.discountPerTicket) {
                        const priceWithoutDiscount = Number(data.quantity) * Number(data.price);
                        const qtyForDiscount = Number(data.quantity) > Number(data.discountCount) ? Number(data.discountCount) : Number(data.quantity);
                        const totalDiscount = Number(data.discountPerTicket) * qtyForDiscount;

                        pricePerTicketWithDiscount = (priceWithoutDiscount - totalDiscount) / Number(data.quantity);
                        discount = totalDiscount / Number(data.quantity);
                    }

                    objectToPush.ecommerce.items.push({
                        item_id: data.eventId,
                        item_name: data.title,
                        item_category: data.category,
                        item_variant: data.variant,
                        item_venue: data.venue,
                        item_location: data.location,
                        item_date: data.date,
                        price: pricePerTicketWithDiscount ?? Number(data.price),
                        discount: discount,
                        coupon: data.discountName ?? undefined,
                        currency: data.currency,
                        quantity: Number(data.quantity),
                        item_list_name: localStorageItem.item_list_name ?? undefined,
                        item_list_id: localStorageItem.item_list_id ?? undefined,
                        index: Number(data.index) + 1,
                        promotion_id: localStorageItem.promotion_id ?? undefined,
                        promotion_name: localStorageItem.promotion_name ?? undefined,
                        creative_slot: localStorageItem.creative_slot ?? undefined,
                        creative_name: localStorageItem.creative_name ?? undefined
                    });
                })

                dataLayer.push(objectToPush);
            }
        }
    }

    window.track.trackBeginCheckout = function(listEl) {
        let localStorageItem = {};
        const listItems = Array.from(listEl.querySelectorAll(':scope .js-track-cart-item'));

        if (typeof dataLayer !== 'undefined' && listItems.length) {
            if (Boolean(JSON.parse(localStorage.getItem('trackSelectPromotion'))) && isLocalStorageAvailable()) {
                localStorageItem = JSON.parse(localStorage.getItem('trackSelectPromotion'));
            } else if (Boolean(JSON.parse(localStorage.getItem('trackItemList'))) && isLocalStorageAvailable()) {
                localStorageItem = JSON.parse(localStorage.getItem('trackItemList'));
            }

            const chunkSize = 20; // max number of objects in items list

            for (let i = 0; i < listItems.length; i += chunkSize) {
                const chunk = listItems.slice(i, i + chunkSize);
                const objectToPush = {
                    event: 'begin_checkout',
                    ecommerce: {}
                };
                objectToPush.ecommerce.items = [];

                chunk.forEach(c => {
                    const data = c.dataset;
                    let pricePerTicketWithDiscount = null;
                    let discount = 0;

                    if (data.discountName && data.discountCount && data.discountPerTicket) {
                        const priceWithoutDiscount = Number(data.quantity) * Number(data.price);
                        const qtyForDiscount = Number(data.quantity) > Number(data.discountCount) ? Number(data.discountCount) : Number(data.quantity);
                        const totalDiscount = Number(data.discountPerTicket) * qtyForDiscount;

                        pricePerTicketWithDiscount = (priceWithoutDiscount - totalDiscount) / Number(data.quantity);
                        discount = totalDiscount / Number(data.quantity);
                    }

                    objectToPush.ecommerce.items.push({
                        item_id: data.eventId,
                        item_name: data.title,
                        item_category: data.category,
                        item_variant: data.variant,
                        item_venue: data.venue,
                        item_location: data.location,
                        item_date: data.date,
                        price: pricePerTicketWithDiscount ?? Number(data.price),
                        discount: discount,
                        coupon: data.discountName ?? undefined,
                        currency: data.currency,
                        quantity: Number(data.quantity),
                        item_list_name: localStorageItem.item_list_name ?? undefined,
                        item_list_id: localStorageItem.item_list_id ?? undefined,
                        index: Number(data.index) + 1,
                        promotion_id: localStorageItem.promotion_id ?? undefined,
                        promotion_name: localStorageItem.promotion_name ?? undefined,
                        creative_slot: localStorageItem.creative_slot ?? undefined,
                        creative_name: localStorageItem.creative_name ?? undefined
                    });
                })

                dataLayer.push(objectToPush);
            }
        }
    }

    window.track.trackPurchase = function(data) {
        let localStorageItem = {};

        if (typeof dataLayer !== 'undefined' && data.ecommerce.items) {
            if (Boolean(JSON.parse(localStorage.getItem('trackSelectPromotion'))) && isLocalStorageAvailable()) {
                localStorageItem = JSON.parse(localStorage.getItem('trackSelectPromotion'));
            } else if (Boolean(JSON.parse(localStorage.getItem('trackItemList'))) && isLocalStorageAvailable()) {
                localStorageItem = JSON.parse(localStorage.getItem('trackItemList'));
            }

            const objectToPush = {
                event: 'purchase',
                ecommerce: {
                    transaction_id: data.ecommerce.transaction_id,
                    affiliation: data.ecommerce.affiliation,
                    value: Number(data.ecommerce.value),
                    ticket_insurance: Number(data.ecommerce.ticket_insurance),
                    tax: Number(data.ecommerce.tax),
                    shipping: Number(data.ecommerce.shipping),
                    currency: data.ecommerce.currency,
                    login_type: data.ecommerce.login_type,
                    shipping_tier: data.ecommerce.shipping_tier,
                    payment_type: data.ecommerce.payment_type,
                    items: []
                }
            };

            data.ecommerce.items.forEach((item, index) => {
                let pricePerTicketWithDiscount = null;
                let discount = 0;

                if (item.coupon && item.discounted_tickets_count && item.discounted_price) {
                    const priceWithoutDiscount = Number(item.quantity) * Number(item.price);
                    const qtyForDiscount = Number(item.quantity) > Number(item.discounted_tickets_count) ? Number(item.discounted_tickets_count) : Number(item.quantity);
                    const totalDiscount = Number(item.discounted_price) * qtyForDiscount;

                    pricePerTicketWithDiscount = (priceWithoutDiscount - totalDiscount) / Number(item.quantity);
                    discount = totalDiscount / Number(item.quantity)
                }

                objectToPush.ecommerce.items.push({
                    item_id: item.item_id,
                    item_name: item.item_name,
                    item_category: item.item_category,
                    item_variant: item.item_variant,
                    item_venue: item.item_venue,
                    item_location: item.item_location,
                    item_date: item.item_date,
                    price: pricePerTicketWithDiscount ?? Number(item.price),
                    discount: discount,
                    coupon: item.coupon ?? undefined,
                    currency: item.currency,
                    quantity: Number(item.quantity),
                    item_list_name: localStorageItem.item_list_name ?? undefined,
                    item_list_id: localStorageItem.item_list_id ?? undefined,
                    index: Number(index) + 1,
                    promotion_id: localStorageItem.promotion_id ?? undefined,
                    promotion_name: localStorageItem.promotion_name ?? undefined,
                    creative_slot: localStorageItem.creative_slot ?? undefined,
                    creative_name: localStorageItem.creative_name ?? undefined
                });
            })

            dataLayer.push(objectToPush);

            if (isLocalStorageAvailable()) {
                if (Boolean(localStorage.getItem('trackSelectPromotion'))) {
                    localStorage.removeItem('trackSelectPromotion')
                }

				if (Boolean(localStorage.getItem('trackItemList'))) {
					localStorage.removeItem('trackItemList')
				}
			}
		}
	}
};
